import isLocalOrDevEnvironment from './isLocalOrDevEnvironment.ts';

// Don't initialize GTM on localhost or dev tunnels
const shouldInitializeGTM = !isLocalOrDevEnvironment;

export const initializeGTM = (id: string) => {
    if (typeof window !== 'undefined' && shouldInitializeGTM && id) {
        const nonce = document.querySelector<HTMLMetaElement>(
            'meta[name="csp-nonce"]'
        )?.content;
        const script = document.createElement('script');
        script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${id}');
    `;
        if (nonce) {
            script.nonce = nonce;
        }
        document.head.insertBefore(script, document.head.firstChild);
    }
};

export const addGTMNoscript = (id: string) => {
    if (typeof window !== 'undefined' && shouldInitializeGTM && id) {
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
    }
};
